var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-head'),_c('div',{staticClass:"zhaunrang minH"},[_c('div',{staticClass:"title"},[_vm._v("查看发布标的")]),_c('zr-details',{attrs:{"id":_vm.$route.query.id}})],1),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }